import React from 'react';
import styles from './style.module.css';
import iconIcSearch from '../../../../assets/ic-dispatching-x.svg';
import confirm from '../../../../assets/ic-confirm-x.svg';
import reject from '../../../../assets/ic-close-red-x.svg';
import dispatch_later_tooltip from '../../../../assets/dispatch_later_tooltip.svg';
import rejected from '../../../../assets/ic-driver-rejected.svg';
import waitconfirm from '../../../../assets/ic-driver-wait-confirm.svg';
import radar from '../../../../assets/ic-radar.svg';
import queue from '../../../../assets/ic-queue.svg';
import noDriver from '../../../../assets/ic-driver-not-selected.svg';
import icDriver from '../../../../assets/ic-driver-new.svg';
import icTimer from '../../../../assets/ic-timer.svg';
import icTimerDelay from '../../../../assets/ic-timer-delay.svg';
import { useTranslation } from 'react-i18next';
import { GetNextStatusInListItem, GetNextStatusListItem } from '../../../../utils/getNextStatus_ListItem';
import momentJalaali from "moment-jalaali";
import { checkTimestamp, get_calendarType, get_lang } from '../../../../helper/UserData/userdate';
import { useState } from 'react';
import { GetColorByStatus } from '../../../../utils/get-colors-by-status';
import { useEffect } from 'react';
import { Tooltip, TooltipProps, tooltipClasses } from 'newmaterial-ui';
import { styled } from 'newmaterial-ui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { SetActiveDriverList, SetDriverListOpenDialoge, SetSelectedMonitoringDriver } from '../../../../Redux/actions/actionNames';
import { GetDriverInfoAction, GetDriverOrderListAction } from '../../../../Redux/actions/actions';
import jalali from "jalali-moment";
import useIsWindowFocused from '../../../../hooks/useIsWindowFocused';
import Axios from 'axios';
import queue_urgent from "../../../../assets/queue_urgent.svg";
import radar_urgent from "../../../../assets/radar_urgent.svg";
import Custom_Box_Grey from '../custom_Box_Grey';
import Typography from '../../../../design-system/lib/Typography';
import { adsigne, CLOCK_1, driver_assign, URGENT } from '../../../../assets';
import IconProvider from '../../../../design-system/lib/IconProvider';
import { CanAssignOrder } from '../../../../helper/module';

const _ = require('lodash');

    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip  {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: ' #fff',
            borderRadius: "8px",
            padding: "0",
            border: 'none',
            boxShadow: "0 4px 12px 0 rgba(0, 0, 0, 0.24)",
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 350,
            fontSize: theme.typography.pxToRem(12),
            marginBottom: "0px !important"
        },
            [`& .${tooltipClasses.arrow}`]: {
                color:"white"
            },
    }));

export const OrderStatusRow = ({ data, showDelayLate, disableListItem , hideDriver , openAA , driver_assignClass}) => {
    const cursor = useSelector((state) => state.OrderList.cursor)
    const cursorSort = useSelector((state) => state.OrderList.cursorSort)
    const activeDriver = useSelector((state) => state.DriversList.activeDriver)

    const { t, i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const dispatch = useDispatch();
    const DispatchLater = data.status == "Pending" && !data.isDispatching && data.driverAssignmentModel == "automatic";

    const getDriverOrders = React.useCallback((id, noLoading) => {

        dispatch(
            GetDriverOrderListAction(dispatch, {
                cursor: cursor,
                cursorSort: cursorSort,
                status: ["Assigned", "PickedUp", "Started", "Arrived"],
                size: 200,
                type: "Ondemand",
                driverId: id,
            }, false)
        );

    }, [cursor, cursorSort]);






    function OpenUserProfile() {
        disableListItem(false)
        if (activeDriver) {
            if (activeDriver.id == data.driverId) {
                dispatch(SetSelectedMonitoringDriver(data.driverId))

                dispatch(SetDriverListOpenDialoge(true))

                getDriverOrders(data.driverId, true)
            } else {
                dispatch(SetActiveDriverList({ ...data.driver, id: data.driverId }));
                dispatch(GetDriverInfoAction(dispatch, data.driverId))
                dispatch(SetSelectedMonitoringDriver(data.driverId))

                dispatch(SetDriverListOpenDialoge(true))

                getDriverOrders(data.driverId, false)
            }

        } else {
            dispatch(SetActiveDriverList({ ...data.driver, id: data.driverId }));
            dispatch(GetDriverInfoAction(dispatch, data.driverId))
            dispatch(SetSelectedMonitoringDriver(data.driverId))

            dispatch(SetDriverListOpenDialoge(true))

            getDriverOrders(data.driverId, false)
        }

    };

    function OpenUserProfileRejectedWaiting() {

        if (activeDriver) {
            if (activeDriver.id == data.driverId) {
                dispatch(SetDriverListOpenDialoge(true))
                dispatch(SetSelectedMonitoringDriver(data.currentCandidateDrivers[0].driverId))
                getDriverOrders(data.driverId, true)

            } else {
                dispatch(SetActiveDriverList({ id: data.currentCandidateDrivers[0].driverId }));
                dispatch(GetDriverInfoAction(dispatch, data.currentCandidateDrivers[0].driverId))
                dispatch(SetSelectedMonitoringDriver(data.currentCandidateDrivers[0].driverId))

                dispatch(SetDriverListOpenDialoge(true))
                getDriverOrders(data.driverId, false)
            }
        } else {
            dispatch(SetActiveDriverList({ id: data.currentCandidateDrivers[0].driverId }));
            dispatch(GetDriverInfoAction(dispatch, data.currentCandidateDrivers[0].driverId))
            dispatch(SetSelectedMonitoringDriver(data.currentCandidateDrivers[0].driverId))

            dispatch(SetDriverListOpenDialoge(true))
            getDriverOrders(data.driverId, false)
        }


    };
    

    return (
        <div className={styles.OrderStatusRowContainer} style={{marginBottom:"2px"}}>
            <Custom_Box_Grey color={`#${GetColorByStatus(data.status)}`} style={{ width: "14px", height: "14px" }} />
            {/* <span className={styles.Status} style={{ color: `#${GetColorByStatus(data.status)}` }}>{t("EDAS_" + data.status)}</span> */}
             <HtmlTooltip arrow title={
                <div className={styles.popUpContainer}>
                    {/* <span className={styles.Status} style={{ color: `#${GetColorByStatus(data.status)}`, padding: "8px" }}>{t("EDAS_" + data.status)}</span> */}
                <span className={styles.Status} style={{ color: "#242424" ,padding:"8px"}}>{data.code}</span>

                </div>
            } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }} >
                <span className={styles.OrderCodeContainer}>
                    {/* <Typography weight='Body_Small_Medium' text={data.code} style={{ color: "#242424" }} /> */}
                     <Typography weight='Body_Small_Medium' text={t("EDAS_" + data.status)} style={{ color: `#${GetColorByStatus(data.status)}` }} />
                </span>

            </HtmlTooltip>
            {(showDelayLate ) && <EtaDelayLateContainer ismedium={false} showStatus={!DispatchLater} disableListItem={disableListItem} status={data.status} realETA={data.realETA} isPossibleForDelay={data.isPossibleForDelay} delayAt={data.delayAt} type={data.type} isDelayed={data.isDelayed} />}
             {
                DispatchLater &&
                <HtmlTooltip arrow title={
                    <div className={styles.popUpContainer}>
                        <div className={styles.popUpTitleDescContainer}>

                            <Typography weight='Body_Small_Medium' text={String(t("Dispatchat")).replace("xxx", jalali(data.dispatchAt)
                                .locale(get_lang())
                                .format(checkTimestamp(data.dispatchAt)))} style={{ color: "#242424", margin: "8px 0px 0px" }} />
 
                            {showDelayLate && <NextStatusMinContainer ismedium={true} justNextStatus={true} disableListItem={disableListItem} status={data.status} realETA={data.realETA} isPossibleForDelay={data.isPossibleForDelay} delayAt={data.delayAt} type={data.type} isDelayed={data.isDelayed} />}

                        </div>
                    </div>
                } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }}>
                    <span className={styles.OrderCodeContainer}>

                        <Typography weight='Body_Small_Medium' text={<><img src={dispatch_later_tooltip} style={{ width: "14px", height: "14px" }} />
                            {
                                jalali(data.dispatchAt)
                                    .locale(get_lang())
                                    .format(checkTimestamp(data.dispatchAt))}  </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", height: "16px", padding: "0px 6px", alignItems:"center" ,  marginInlineEnd: "6px", borderInlineStart: "1px solid #F4F4F7" , marginInlineStart: "6px", paddingInlineStart: "6px" ,alignItems:"center" }} />

                    </span>
                </HtmlTooltip>

            } 
            {((["Pending" , "Unassigned"].indexOf(data.status) > -1 && CanAssignOrder(data.type))) && <div onClick={openAA} className={styles.tillAt +" "+ driver_assignClass }><IconProvider Icon={driver_assign} /> </div>  }


        <div style={{flex:"1" , display:"flex" , justifyContent:"flex-end" , alignItems:"center"}}>


            {(!_.isEmpty(data.driver) && !DispatchLater && !hideDriver) && <HtmlTooltip arrow title={
                <div className={styles.popUpContainer}>
                    <div className={styles.popUpTitleDescContainer} style={{ padding:"8px"}}>
                  <Typography weight='Body_Small_Medium' text={<> {data.driver.name}  </>} style={{ color: "#242424" }} />

                    </div>
                    <div style={{display:"flex",flexDirection:"row" ,justifyContent:"center" , alignItems:"center",gap :"6px", height: "16px" ,margin :"0px 8px 8px" }} >
                        <Typography  onClick={OpenUserProfile}  weight='Body_Small_Medium' text={<><img src={adsigne} style={{ width: "14px", height: "14px" }} />{data.driver?.username}  </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center" , textDecoration : "underline"  ,cursor :"pointer"}} />
  
                     </div>
                </div>
            } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }} >
                <span className={styles.OrderStatusRowContainerInner}>
                 <Typography weight='Body_Small_Medium' text={<><img src={icDriver} style={{ width: "14px", height: "14px" }} />{data.driver?.username}  </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", height: "16px", padding: "0px 6px", alignItems:"center" ,  marginInlineEnd: "6px", borderInlineEnd: "1px solid #F4F4F7" }} />
 
                    </span>
            </HtmlTooltip>}


            {(_.isEmpty(data.driver) && !DispatchLater && ["Pending"].indexOf(data.status) == -1 && data.type != "PickupDelivery"  && !hideDriver) &&
                 <Typography weight='Body_Small_Medium' text={<><img src={noDriver} style={{ width: "14px", height: "14px" }} /> {t("NoDriver")}  </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", height: "16px", padding: "0px 6px", alignItems:"center" ,  marginInlineEnd: "6px", borderInlineEnd: "1px solid #F4F4F7" }} />
            }

             {
                (["Pending"].indexOf(data.status) > -1 && !DispatchLater && data.driverAssignmentModel == "automatic" && _.isEmpty(data.driver  && !hideDriver) && data.candidateDriversCount == 0) &&
                <HtmlTooltip arrow title={
                    <div className={styles.popUpContainer}>
                        <div className={styles.popUpTitleDescContainer} style={{padding:"8px"}}>
                           <Typography weight='Body_Small_Medium' text={<>  {t("Waitingforavailabledrivers")}  </>} style={{ color: "#242424"  }} />
                          { data.isUrgent && <Typography weight='Body_Small_Regular' text={<><img src={ URGENT } style={{ width: "14px", height: "14px" }} />  {t("Urgent")}  </>} style={{ color: "#242424" , marginTop :"8px" , display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center" }} />
}
                        </div>
                    </div>
                } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }}>
                    <span className={styles.OrderStatusRowContainerInner}>
 
                 <Typography weight='Body_Small_Medium' text={<><img src={data.isUrgent ? queue_urgent : queue} style={{ width: "14px", height: "14px" }} /> {t("Queue")}  </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", height: "16px", padding: "0px 6px", alignItems:"center" ,  marginInlineEnd: "6px", borderInlineEnd: "1px solid #F4F4F7" }} />

                        </span>
                </HtmlTooltip>

            } 


        





             {
                (["Pending"].indexOf(data.status) > -1 && !DispatchLater && data.driverAssignmentModel == "automatic" && _.isEmpty(data.driver && !hideDriver) && data.candidateDriversCount > 0) &&
                <HtmlTooltip arrow title={
                    <div className={styles.popUpContainer}>
                            <div className={styles.popUpTitleDescContainer} style={{padding:"8px"}}>
                           <Typography weight='Body_Small_Medium' text={String(t("OfferingToDrivers")).replace("xxx", data.candidateDriversCount)} style={{ color: "#242424"  }} />
                         </div>
                    </div>
                } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }}>
                    <span className={styles.OrderStatusRowContainerInner}>
      
                   <Typography weight='Body_Small_Medium' text={<><img src={data.isUrgent ? radar_urgent : radar} style={{ width: "14px", height: "14px" }} /> {data.candidateDriversCount}  </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", height: "16px", padding: "0px 6px", alignItems:"center" ,  marginInlineEnd: "6px", borderInlineEnd: "1px solid #F4F4F7" }} />

                        </span>
                </HtmlTooltip>

            }  




                {
                    (["Pending"].indexOf(data.status) > -1 && !DispatchLater && data.driverAssignmentModel == "manual" && _.isEmpty(data.driver && !hideDriver) && data.currentCandidateDrivers[0] && ["received", "notifying", "initial"].indexOf(data.currentCandidateDrivers[0].status) > -1) &&
                    <HtmlTooltip arrow title={
                        <div className={styles.popUpContainer}>
                            <div className={styles.popUpTitleDescContainer} style={{ padding: "8px" }}>
                                <Typography weight='Body_Small_Medium' text={data.currentCandidateDrivers[0].name} style={{ color: "#242424" }} />

                            </div>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "6px", height: "16px", margin: "0px 8px 8px" }} >
                                <Typography  onClick={OpenUserProfileRejectedWaiting}  weight='Body_Small_Medium' text={<><img src={adsigne} style={{ width: "14px", height: "14px" }} />{data.currentCandidateDrivers[0].username}  </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center" , textDecoration : "underline"  ,cursor :"pointer"}} />
                                <span style={{ height: "16px", width: "1px", backgroundColor: "#80808033" }} />
                                <Typography weight='Body_Small_Medium' text={<><img src={waitconfirm} style={{ width: "14px", height: "14px" }} />{t("WaitforAccept")}   </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center" }} />

                            </div>



                        </div>
                    } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }}>
                        <span className={styles.OrderStatusRowContainerInner}>

                            <Typography weight='Body_Small_Medium' text={<><img src={waitconfirm} style={{ width: "14px", height: "14px" }} /> {data.currentCandidateDrivers[0].username}  </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", height: "16px", padding: "0px 6px", alignItems:"center" ,  marginInlineEnd: "6px", borderInlineEnd: "1px solid #F4F4F7" }} />

                        </span>
                    </HtmlTooltip>

                }




                {
                    (["Pending"].indexOf(data.status) > -1 && !DispatchLater && data.driverAssignmentModel == "manual" && _.isEmpty(data.driver && !hideDriver) && data.currentCandidateDrivers[0] && ["rejected"].indexOf(data.currentCandidateDrivers[0].status) > -1) &&
                    <HtmlTooltip arrow title={
                        <div className={styles.popUpContainer}>

                            <div className={styles.popUpTitleDescContainer} style={{ padding: "8px" }}>
                                <Typography weight='Body_Small_Medium' text={data.currentCandidateDrivers[0].name} style={{ color: "#242424" }} />

                            </div>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "6px", height: "16px", margin: "0px 8px 8px" }} >
                                <Typography onClick={OpenUserProfileRejectedWaiting} weight='Body_Small_Medium' text={<><img src={adsigne} style={{ width: "14px", height: "14px" }} />{data.currentCandidateDrivers[0].username}  </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", textDecoration : "underline" ,cursor :"pointer" }} />
                                <span style={{ height: "16px", width: "1px", backgroundColor: "#80808033" }} />
                                <Typography weight='Body_Small_Medium' text={<><img src={rejected} style={{ width: "14px", height: "14px" }} />{t("Rejected")}   </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center" }} />

                            </div>

                        </div>
                    } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }}>
                        <span className={styles.OrderStatusRowContainerInner}>

                            <Typography weight='Body_Small_Medium' text={<><img src={rejected} style={{ width: "14px", height: "14px" }} /> {data.currentCandidateDrivers[0].username}  </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", height: "16px", padding: "0px 6px", alignItems:"center" ,  marginInlineEnd: "6px", borderInlineEnd: "1px solid #F4F4F7" }} />

                        </span>
                    </HtmlTooltip>

                }


  {(data.vehicleType && data.type != "PickupDelivery") &&
                <HtmlTooltip arrow title={
                    <div className={styles.popUpContainer}>
                        <div className={styles.popUpTitleDescContainer}  style={{ padding:"8px"}}>
                           <Typography weight='Body_Small_Medium' text={<> {data.vehicleType.title}  </>} style={{ color: "#242424" }} />

                         </div>
                    </div>
                } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }}>
                    <span className={styles.OrderStatusRowContainerInner} style={{margin:"0px"}}  >
                        <img src={data.vehicleType.icon} style={{ height: "16px"  }} />
                        {/* <span className={styles.Dispatching} style={{ maxWidth: "65px" }}> {data.vehicleType.title} </span> */}
                        </span>
                </HtmlTooltip>

            }
</div>



          

        </div>
    );
};



export const EtaDelayLateContainer = ({ status, realETA, isPossibleForDelay, delayAt, type, isDelayed, disableListItem ,justNextStatus ,showStatus , ismedium}) => {
    const { t, i18n } = useTranslation();
    const [nextStatusMin, setNextStatusMin] = React.useState(0);

    useEffect(() => {
        if (realETA && !isPossibleForDelay && !isDelayed) {
            let from = Math.floor(Date.now() / 1000);
            let to = momentJalaali(realETA).locale(get_calendarType()).unix();
            if (to >= from) {
                let min = (to - from) / 60;
                setNextStatusMin(Math.round(min));
                const interval = setInterval(() => {
                    let from = Math.floor(Date.now() / 1000);
                    let min = (to - from) / 60;

                    setNextStatusMin(Math.round(min));
                }, 20000);
                return () => clearInterval(interval);
            }
        }
    }, [realETA, isPossibleForDelay, isDelayed]);


 
  function getduration(minutesIn) {
        let durationString = '';

        if (minutesIn < 60) {
             durationString = `${minutesIn}m`;
        } else {
            let chours = Math.floor(minutesIn / 60);
            let cminutes = Math.floor((minutesIn % 60) );
            if (cminutes > 0) {
                durationString = `${chours}h, ${cminutes}m`;
            } else {
                durationString = `${chours}h`;
            }
        } 
        
        return durationString
    }




    if (["Pending", "Assigned", "Started", "Arrived", "PickedUp"].indexOf(status) > -1) {
        if(justNextStatus){
            return <span className={styles.tillAt}> {/* <img src={icTimer} alt="" className={styles.icTimer} /> */} {String(t(`${GetNextStatusInListItem(status, type)}`)).replace("xxx", /* nextStatusMin*/ jalali(realETA)
                                .locale(get_lang())
                                .format(checkTimestamp(realETA)))} </span>
        }
        if (realETA) {
            if (isPossibleForDelay) {
                return <LateComponent disableListItem={disableListItem} status={status} realETA={realETA} delayAt={delayAt} type={type} />
            } else if (isDelayed) {
                return <DelayComponent disableListItem={disableListItem} status={status} realETA={realETA} delayAt={delayAt} type={type} />
            } else if (nextStatusMin > 0 && showStatus) {
                return ismedium ? <Typography weight='Body_Small_Medium' text={<><img src={CLOCK_1} style={{ width: "14px", height: "14px" }} /> {getduration(nextStatusMin)} </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", height: "16px", padding: "0px 6px", alignItems:"center" ,  marginInlineStart: "6px", borderInlineStart: "1px solid #F4F4F7" }} /> :
                    <HtmlTooltip arrow title={
                        <div className={styles.popUpContainer}>
                            <div className={styles.popUpTitleDescContainer}>
                                <NextStatusMinContainer ismedium={false} justNextStatus={true} disableListItem={disableListItem} status={status} realETA={realETA} isPossibleForDelay={isPossibleForDelay} delayAt={delayAt} type={type} isDelayed={isDelayed} />
                            </div>
                        </div>
                    } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }}>
                        <span className={styles.OrderCodeContainer} >
                            <Typography weight='Body_Small_Medium' text={<><img src={CLOCK_1} style={{ width: "14px", height: "14px" }} /> {getduration(nextStatusMin)} </>} style={{ color: "#242424", margin: "0px", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", height: "16px", padding: "0px 6px", alignItems:"center" ,  marginInlineStart: "6px", borderInlineStart: "1px solid #F4F4F7" }} />                         </span>
                    </HtmlTooltip>

            } else {
                return null
            }
        } else {
            return null
        }
    } else {

        return null
    }
};

export const NextStatusMinContainer = ({ status, realETA, isPossibleForDelay, delayAt, type, isDelayed, disableListItem ,justNextStatus ,showStatus ,ismedium = true}) => {
    const { t, i18n } = useTranslation();
    const [nextStatusMin, setNextStatusMin] = React.useState(0);



 



    
    useEffect(() => {
        if (realETA && !isPossibleForDelay && !isDelayed) {
            let from = Math.floor(Date.now() / 1000);
            let to = momentJalaali(realETA).locale(get_calendarType()).unix();
            if (to >= from) {
                let min = (to - from) / 60;
                setNextStatusMin(Math.round(min));
                const interval = setInterval(() => {
                    let from = Math.floor(Date.now() / 1000);
                    let min = (to - from) / 60;

                    setNextStatusMin(Math.round(min));
                }, 20000);
                return () => clearInterval(interval);
            }
        }
    }, [realETA, isPossibleForDelay, isDelayed]);


    if (["Pending", "Assigned", "Started", "Arrived", "PickedUp"].indexOf(status) > -1) {

        if (realETA) {
            if (!isPossibleForDelay && !isDelayed) {
                if (nextStatusMin > 0) {
                   return ismedium ? <Typography weight='Body_Small_Regular' text={<>  <img src={CLOCK_1} style={{width:"14px",height:"14px"}} />  {String(t(`${GetNextStatusInListItem(status, type)}`)).replace("xxx", jalali(realETA)
                                .locale(get_lang())
                                .format(checkTimestamp(realETA)))} </>} style={{ color: "#242424", margin: "8px 0px 0px" ,display:"flex" , flexDirection :"row" , gap:"2px" , justifyContent:"center" ,height:"16px" }} /> :
                     <HtmlTooltip arrow title={
                    <div className={styles.popUpContainer}>
                        <div className={styles.popUpTitleDescContainer}>
                         </div>
                    </div>
                } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }}>
                    <span className={styles.OrderStatusRowContainerInner} >
                         <Typography weight='Body_Small_Medium' text={<>  {String(t(`${GetNextStatusInListItem(status, type)}`)).replace("xxx", jalali(realETA)
                                .locale(get_lang())
                                .format(checkTimestamp(realETA)))} </>} style={{ color: "#242424", margin: "8px 0px 0px" ,display:"flex" , flexDirection :"row" , gap:"2px" , justifyContent:"center" ,height:"16px" }} />
                       </span>
                </HtmlTooltip>
                  
                 } else {
                    return null
                }
            } else {
                return null
            }
        } else {

            return null
        }
    };
}


export const LateComponent = ({ status, realETA, delayAt, type, disableListItem }) => {
    const { t, i18n } = useTranslation();
    let minutes = Math.round(parseInt(Math.abs(realETA - delayAt) / 1000) / 60) ;

 

        function getduration(minutesIn) {
        let durationString = '';

        if (minutesIn < 60) {
             durationString = `${minutesIn}m`;
        } else {
            let chours = Math.floor(minutesIn / 60);
            let cminutes = Math.floor((minutesIn % 60) );
            if (cminutes > 0) {
                durationString = `${chours}h, ${cminutes}m`;
            } else {
                durationString = `${chours}h`;
            }
        } 
        
        return durationString
    }

    return <>



        {/* <span className={styles.tillAt}> <img className={styles.icTimer} src={icTimer} alt="" />  {String(t(`${GetNextStatusInListItem(status, type)}`)).replace("xxx", momentJalaali(realETA).locale(get_calendarType()).format("HH:mm"))} </span> */}
        {Number(minutes) > 0 && <HtmlTooltip arrow title={
            <div className={styles.popUpContainer}>
                <Typography weight='Body_Small_Medium' text={`${String(t("Latexmin")).replace("xxx", getduration(minutes))}`} style={{ color: "#D01400", marginTop: "8px", marginBottom: "8px" }} />
                <Typography weight='Body_Small_Regular' text={<><img className={styles.icTimer} src={CLOCK_1} alt="" />{String(t(`${GetNextStatusInListItem(status, type)}`)).replace("xxx", jalali(realETA)
                                .locale(get_lang())
                                .format(checkTimestamp(realETA)))}</>} style={{ color: "#242424", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", margin: "0px 8px 8px" }} />
            </div>
        } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }} >
            <span className={styles.OrderCodeContainer}>
                <span className={styles.tillAt}>  <img className={styles.icTimer} src={icTimerDelay} alt="" />

                    <Typography weight='Body_Small_Medium' text={`${getduration(minutes)}`} style={{ color: "#D01400" }} /> </span>
            </span>

        </HtmlTooltip>
        }
    </>
    // return <span className={styles.tillAt}>
    //     <span className={styles.delayRed}><img className={styles.icTimer} src={icTimerDelay} alt="" /> {String(t(`minlate`)).replace("xxx", minutes)}</span>
    //     ({String(t(`${GetNextStatusInListItem(status, type)}`)).replace("xxx", momentJalaali(realETA).locale(get_calendarType()).format("HH:mm"))})
    // </span>
}

 

export const DelayComponent = ({ status, realETA, delayAt, type, disableListItem }) => {
    const { t, i18n } = useTranslation();
    const [minutes, setMinutes] = useState(0);
    const windowIsActive = useIsWindowFocused();
    const timestamp = useSelector((state) => state.LocalData.timestamp)



    // function getMinute(ddd) {
    //     return Math.round(parseInt(Math.abs(timestamp - delayAt) / 1000) / 60)
    // }


    // useEffect(() => {

    //     Axios.get('https://worldtimeapi.org/api/ip')
    //     .then((response)=> {
    //         // handle success
    //         setMinutes(getMinute(Number(response.data.unixtime + '000')))
    //     })
    //     .catch( (error)=> {
    //         // handle error

    //         setMinutes(getMinute(Date.now()))
    //     })

    // }, [windowIsActive]);


    // useEffect(() => {
    //     Axios.get('https://worldtimeapi.org/api/ip')
    //     .then((response)=> {
    //         // handle success
    //         setMinutes(getMinute(Number(response.data.unixtime + '000')))
    //     })
    //     .catch( (error)=> {
    //         // handle error

    //         setMinutes(getMinute(Date.now()))
    //     })
    //     const newIntervalId = setInterval(() => {
    //         Axios.get('https://worldtimeapi.org/api/ip')
    //         .then((response)=> {
    //             // handle success
    //             setMinutes(getMinute(Number(response.data.unixtime + '000')))
    //         })
    //         .catch( (error)=> {
    //             // handle error

    //             setMinutes(getMinute(Date.now()))
    //         })
    //     }, 50000);
    //     return () => clearInterval(newIntervalId);
    // }, [windowIsActive]);



    function getduration(minutesIn) {
        let durationString = '';

        if (minutesIn < 60) {
             durationString = `${minutesIn}m`;
        } else {
            let chours = Math.floor(minutesIn / 60);
            let cminutes = Math.floor((minutesIn % 60) );
            if (cminutes > 0) {
                durationString = `${chours}h, ${cminutes}m`;
            } else {
                durationString = `${chours}h`;
            }
        } 
        
        return durationString
    }

    return <>
        {/* <span className={styles.tillAt}> <img className={styles.icTimer} src={icTimer} alt="" />  {String(t(`${GetNextStatusInListItem(status, type)}`)).replace("xxx", momentJalaali(realETA).locale(get_calendarType()).format("HH:mm"))} </span> */}
        {Number(timestamp) > 0 &&
            <HtmlTooltip arrow title={
                <div className={styles.popUpContainer}>
                    <Typography weight='Body_Small_Medium' text={`${String(t("Delayxmin")).replace("xxx", getduration(parseInt(Math.abs(timestamp - delayAt) / 1000 / 60)))}`} style={{ color: "#D01400", marginTop: "8px", marginBottom: "8px" }} />
                    <Typography weight='Body_Small_Regular' text={<><img className={styles.icTimer} src={CLOCK_1} alt="" />{String(t(`${GetNextStatusInListItem(status, type)}`)).replace("xxx", jalali(realETA)
                                .locale(get_lang())
                                .format(checkTimestamp(realETA)))}</>} style={{ color: "#242424", display: "flex", flexDirection: "row", gap: "2px", justifyContent: "center", margin: "0px 8px 8px" }} />
                </div>
            } placement="top" onOpen={() => { disableListItem(true) }} onClose={() => { disableListItem(false) }} >
                <span className={styles.OrderCodeContainer}>
                    <span className={styles.tillAt}>  <img className={styles.icTimer} src={icTimerDelay} alt="" /> <Typography weight='Body_Small_Medium' text={`${ getduration(parseInt(Math.abs(timestamp - delayAt) / 1000 / 60))}`} style={{ color: "#D01400" }} /> </span>
                </span>

            </HtmlTooltip>
        } </>
    // return <span className={styles.tillAt}> <span className={styles.delayRed}><img className={styles.icTimer} src={icTimerDelay} alt="" />  {String(t(`mindelay`)).replace("xxx", minutes)}</span> ({String(t(`${GetNextStatusInListItem(status, type)}`)).replace("xxx", momentJalaali(realETA).locale(get_calendarType()).format("HH:mm"))}) </span>
}
